import { call, put, takeLatest } from 'redux-saga/effects';

import { DELETE_BLACK_LIST_REQUEST, GET_BLACK_LIST_REQUEST, POST_BLACK_LIST_REQUEST } from './constants';
import {
  deleteBlackListError,
  deleteBlackListRequest,
  deleteBlackListSuccess,
  getBlackListError,
  getBlackListRequest,
  getBlackListSuccess,
  postBlackListError,
  postBlackListRequest,
  postBlackListSuccess,
} from './actions';
import { BlackListService } from '../../../../entities/BlackList/services';

function* getBlackListSaga() {
  try {
    // @ts-ignore
    const reports: any = yield call(BlackListService.getBlackList);
    yield put(getBlackListSuccess(reports));
  } catch (error: any) {
    yield put(getBlackListError(error));
  }
}

function* postBlackListSaga(action: ReturnType<typeof postBlackListRequest>) {
  try {
    // @ts-ignore
    yield call(BlackListService.postBlList, action.payload);
    yield put(postBlackListSuccess());
    yield put(getBlackListRequest());
  } catch (error: any) {
    yield put(postBlackListError(error));
  }
}

function* deleteBlackListSaga(action: ReturnType<typeof deleteBlackListRequest>) {
  try {
    // @ts-ignore
    yield call(BlackListService.deleteBlList, action.payload);
    yield put(deleteBlackListSuccess());
    yield put(getBlackListRequest());
  } catch (error: any) {
    yield put(deleteBlackListError(error));
  }
}

export function* blackListSagaWatcher() {
  yield takeLatest(GET_BLACK_LIST_REQUEST, getBlackListSaga);
  yield takeLatest(POST_BLACK_LIST_REQUEST, postBlackListSaga);
  yield takeLatest(DELETE_BLACK_LIST_REQUEST, deleteBlackListSaga);
}
